export default __webpack_public_path__ + "static/media/logoSmall.6fd475eb.png";